/**
 * Pricing Constants - Canonical Truth
 * Based on CURSOR_SESSION_BRIEF.md
 */

export const PRICING = {
  MIN_BASE_PRICE: 20,
  LAUNCH_FEE: 15,
  SPLIT: { 
    base: { creator: 0.5, platform: 0.5 }, 
    launchFeeAllToPlatform: true 
  }
};

// Launch pricing for different user types
export const LAUNCH_PRICING = {
  CREATOR_OWN_GAME: 15,       // $15 for creators launching their own games
  MARKETPLACE_BASE: 35,       // $35 base for marketplace games (20 + 15)
};

// Revenue split calculations
export const calculateRevenueSplit = (basePrice) => {
  const creatorShare = basePrice * PRICING.SPLIT.base.creator;
  const platformShare = basePrice * PRICING.SPLIT.base.platform;
  const launchFee = PRICING.LAUNCH_FEE;
  
  return {
    basePrice,
    creatorShare,
    platformShare,
    launchFee,
    totalCheckout: basePrice + launchFee,
    creatorTotal: creatorShare,
    platformTotal: platformShare + launchFee
  };
};

// Validate pricing constraints
export const validatePricing = (basePrice) => {
  return basePrice >= PRICING.MIN_BASE_PRICE;
};

// Get launch price for user/game combination
export const getLaunchPrice = (isOwnGame) => {
  return isOwnGame ? LAUNCH_PRICING.CREATOR_OWN_GAME : null; // Marketplace games use dynamic pricing
};
